import { render, staticRenderFns } from "./LangCheck.vue?vue&type=template&id=4239bb34&scoped=true&"
import script from "./LangCheck.vue?vue&type=script&lang=js&"
export * from "./LangCheck.vue?vue&type=script&lang=js&"
import style0 from "./LangCheck.vue?vue&type=style&index=0&id=4239bb34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239bb34",
  null
  
)

export default component.exports